'use strict';

MxViewGroupByCtrl.$inject = ['$scope', 'mx.internationalization'];

export function MxViewGroupByCtrl($scope, i18n) {
	this.i18n = i18n;

	this.disableGroupingForColumn = async (column) => {
		await this.groupingPreprocessor.disableGroupingForColumn(column);
		$scope.$evalAsync();
	};
}
